import { View } from '@react-pdf/renderer';
import { ResumeCertificate } from 'lib/redux/types';
import React from 'react'
import { TemplateNineResumeSection, TemplateNineResumeSectionWithSubsections } from './common';
import { spacing, styles } from '../ResumePDF/styles';
import { ProjectPDFLink, ResumePDFDescription, ResumePDFText } from '../ResumePDF/common';
import { ResumePDFIcon } from '../ResumePDF/common/ResumePDFIcon';

const Certificate = ({
    heading,
    certifications,
    themeColor,
    isPDF,
}:{
    heading:string;
    certifications:ResumeCertificate[];
    themeColor:string;
    isPDF:boolean
}) => {
  return (
    <TemplateNineResumeSectionWithSubsections themeColor={themeColor} heading={heading}>
      {
        certifications.map(({certificate,certificateLink,descriptions},idx)=>(
          <View key={idx} wrap={false} >
            <View 
            style={{
              ...styles.flexRowBetween,
              marginTop:spacing["0.5"]
            }}
            >
              <View style={{
                ...styles.flexRow,
                gap:spacing["2"],
                
              }}>
                <ResumePDFText bold={true}>{certificate} </ResumePDFText>
                {
                  certificateLink &&(
                    <ProjectPDFLink src={certificateLink}>

                      <ResumePDFIcon type="url" isPDF={isPDF} themeColor={themeColor} />
                    </ProjectPDFLink>
                  )
                }
              </View>

            </View>
            <View style={{
              ...styles.flexCol,marginTop:spacing["0.5"]
             }}>
              <ResumePDFDescription items={descriptions} />
            </View>
            
          </View>
        ))
      }


    </TemplateNineResumeSectionWithSubsections>
  )
}

export default Certificate
